import { render } from "./authentication-settings.vue?vue&type=template&id=009b069a"
import script from "./authentication-settings.vue?vue&type=script&lang=js"
export * from "./authentication-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__